module.exports = __webpack_public_path__ + "static/img/Jake_Lloyd_desktop.0319f0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jake_Lloyd_desktop.jpg
// module id = xnD/
// module chunks = 0